import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { IDtoResourceCheck, DtoResourceCheck } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoResourceCheckEntityDataService } from '../interfaces/dto.resource.check.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoResourceCheckEntityDataService extends EntityDataService<IDtoResourceCheck> implements IDtoResourceCheckEntityDataService {

    constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
        super(http, null, configService, loggingService);
    }

    protected override doGetApiUrl(): string {
        return '/api/web/resourcecheck';
    }

    protected override createEntityFromJson(json: any): IDtoResourceCheck {
        const result: IDtoResourceCheck = (UtilsJson.deserialize(json, DtoResourceCheck) as IDtoResourceCheck);
        if (result !== null) {
            result.setReferences();
        }

        return result;
    }

}
